var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSafety02 = function SvgSafety02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "safety-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#safety-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.701 12.434v-.76H11.7v-.004L9.39 4.632l-1.604.006v3.856c0 .954-.773 1.726-1.727 1.726V12.436h5.641v-.002Zm6.239-2.212v2.214h-5.641v-.761l2.309-7.042 1.605.006v3.856c0 .954.773 1.727 1.727 1.727Zm-6.239 5.196v2.59H11.7l-5.638-.002v-2.59l5.638.002h.001Zm-5.639-2.382h5.64v1.78h-5.64v-1.78Zm11.874 0H12.3v1.78h5.637v-1.78Zm-5.637 2.38h5.637v2.59H12.3v-2.59Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "safety-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgSafety02 as ReactComponent };